import React from 'react';
import { Icon } from 'semantic-ui-react';

const ContactUsForm = (props) => {
    const { show }  = props;
    return  (
        <div
            className="modal"
            style={{ display: show }}
            onClick={props.handleClose}
         >
            <div className="modal__content">
                <div className="modal__close" onClick={props.closeModal}>
                    <Icon name="close" />
                </div>
                
                
                <div className="modal__body">
                    This is the modal body
                
                </div>
            </div>
        </div>
    )
}

export default ContactUsForm;


// WEBPACK FOOTER //
// ./src/components/contact-us/contact-us.js